import axios from "axios";
const createGrilles = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_BASE_URL}/grille/create`, data)
    .then((response) => {
      return response.data;
    });
};

const updateGrilles = (grilleId, data) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/grille/update/${grilleId}`,
      data
    )
    .then((response) => {
      return response.data;
    });
};

const allGrilles = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/grille/list?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};

const getGrillesByTenantId = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/grille/by-tenant?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const getMesGrilles = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/grille/MesGrids?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const getMesGridsDesactivee = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/grille/MesGridsDesactivee?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const allGrillesDesactiver = (page, size) => {
  return axios
     .get(`${process.env.REACT_APP_API_BASE_URL}/grille/listdesactiver/by-tenant?page=${page}&size=${size}`)
     .then((response) => {
      return response.data;
    });
};
const oneGrille = (grilleId) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/grille/one/${grilleId}`)
    .then((response) => {
      return response.data;
    });
};
const DeactivateGrille = (grilleId) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/grille/activate-deactivate/${grilleId}`
    )
    .then((response) => {
      return response.data;
    });
};

const search = (page, size, status, keybord) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/grille/search/by-tenant?page=${page}&size=${size}&status=${status}&Keybord=${keybord}`)
    .then((response) => {
      return response.data;
    });
};

const searchMygrids =  (page, size, status, keybord) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/grille/serchMyGrids?page=${page}&size=${size}&status=${status}&Keybord=${keybord}`)
    .then((response) => {
      return response.data;
    });
};

const checkGrid = (grilleId) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/grille/checkGrid/${grilleId}`)
    .then((response) => {
      return response.data;
    });
};
const getAllGrids = () => {
  return axios
  .get(`${process.env.REACT_APP_API_BASE_URL}/grille/AllGrids`)
  .then((response) => {
    return response.data;
  });
}
export default {
  allGrilles,
  createGrilles,
  oneGrille,
  allGrillesDesactiver,
  DeactivateGrille,
  search,
  updateGrilles,
  checkGrid,
  getGrillesByTenantId,
  getMesGrilles,
  getMesGridsDesactivee,
  getAllGrids,
  searchMygrids
};
